import {
    CodeBlock,
    BlockType,
    SettingType,
    ValidationMessage,
    ValidationMessageType,
    TibboDataType,
    IOLinesMode,
    IOMode,
} from '@appblocks/codegeneration/types';
import PlatformUtils from '@appblocks/platforms/PlatformUtils';
import IOTibbit from '@appblocks/codegeneration/Tibbits/_IOTibbit';

export default class Tibbit_04_4 extends IOTibbit {
    constructor() {
        super();
        this.id = 'tibbit_04_4';
        this.name = 'Tibbit 04_4';
        this.lines = 4;
        this.mode = IOMode.INPUT;
        this.initLines();
    }
}
